/**
 * Model class containing all the data needed to populate the "header" of a SmartComponent belonging
 * to one of the "counter" type (IE: ELECTRIC, HOT_WATER, COLD_WATER, HEATING, DISTRIBUTOR, GAS).
 *
 */
export class CounterHeaderData {
    public titleWidget: string = ""; //From skill "name"
    public subtitle: string = ""; //??
    public title1: string = ""; //From local/peculiar sub-type of counter
    public title2: string = ""; //From local/peculiar sub-type of counter
    public title3: string = ""; //From local/peculiar sub-type of counter
    public value1: string = ""; //From API "GET .../measurement/ID_SmartComponent"
    public value2: string = "";
    public value3: string = "";

    constructor () { }
}
